import { render, staticRenderFns } from "./search-page.vue?vue&type=template&id=5a2f4765&scoped=true&"
import script from "./search-page.vue?vue&type=script&lang=js&"
export * from "./search-page.vue?vue&type=script&lang=js&"
import style0 from "./search-page.vue?vue&type=style&index=0&id=5a2f4765&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2f4765",
  null
  
)

export default component.exports